import { render } from "./ValidateUBL.vue?vue&type=template&id=23152d34&scoped=true"
import script from "./ValidateUBL.vue?vue&type=script&lang=js"
export * from "./ValidateUBL.vue?vue&type=script&lang=js"

import "./ValidateUBL.vue?vue&type=style&index=0&id=23152d34&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23152d34"]])

export default __exports__